module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/3-b7f48d5fd5e3ddf612dd0f1f8b9f62b3.svg";